import React from 'react';
import { Chip } from "@orijinworks/frontend-commons";
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './ssoEnabledChip.style';

const SSOEnabledChipComponent = ({ classes, enabled = true }) => {
  return enabled && (
    <Chip
      icon={
        <ShieldOutlinedIcon className={classes.icon} />
      }
      label={"Configured with SSO"}
      variant="outlined"
      size="small"
      classes={{
        root: classes.rootChip,
        outlined: classes.chipOutlined,
      }}
    />
  );
};

SSOEnabledChipComponent.propTypes = {
  enabled: PropTypes.bool,
  classes: PropTypes.object.isRequired,
};

export const SSOEnabledChip = withStyles(styles)(SSOEnabledChipComponent);